import React,{useState, useRef} from "react";
import { useNavigate } from "react-router-dom";

import emailjs from "@emailjs/browser";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  servicesOption,
  selectCity,
  hearaboutusOption,
  styles,
} from "../../script";
const animatedComponents = makeAnimated();

export default function HomeForm(){
  
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const history = useNavigate(); // Get the history object from React Router
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailInput = form.current["email"].value;
    if (!emailRegex.test(emailInput)) {
      alert("Please enter a valid email address.");
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          setShowSuccessMessage(true); // Show the popup message

        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };

  const handleReload = () => {
    setShowSuccessMessage(false); // Hide the popup message
    history("/"); // Navigate to the homepage
    window.location.reload(); // Reload the page
  };

return(
<>
       {/* -------------- CONTACT --------------Í */}
        <section id="contact" className="contact">
          <div className="container">
            <h2
              className="section-header whiteDash"
              data-aos="zoom-in"
              data-aos-duration="1500"
              style={{ color: "var(--white-color)" }}
            >
              Contact
            </h2>
            <div className="row" data-aos="fade-up" data-aos-duration="1500">
              <div className="col-lg-6">
                <div className="info-box mb-4">
                  <i className="fa-solid fa-location-dot"></i>
                  <h3>Our Address</h3>
                  <p>
                    Mailing Address: Suite #314 1641 Lonsdale Ave, North
                    Vancouver, BC, V7M 2J5
                  </p>
                  <p>
                  Shop Address: A-2323 Old Dollaton Rd, North Vancouver, BC, V7H 1A9
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="info-box mb-4">
                  <i className="fa-solid fa-envelope"></i>
                  <h3>Email Us</h3>
                  <a
                    href="mailto:gardenandlawncare@bur-han.ca"
                    style={{ textDecoration: "none" }}
                  >
                    <p>gardenandlawncare@bur-han.ca</p>
                  </a>
                  <br />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="info-box mb-4">
                  <i className="fa-solid fa-phone"></i>
                  <h3>Call Us</h3>
                  <a href="tel:604-983-2687" style={{ textDecoration: "none" }}>
                    <p>(604) 983-2687</p>
                  </a>
                  <br />
                </div>
              </div>
            </div>
            <div className="row" data-aos="fade-up" data-aos-duration="2500">
              <div className="col-lg-6 ">
              <iframe
                  title="BUR-HAN Garden & Lawn Care Location Map"
                  style={{ height: "100%", width: "100%", border: "0" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2601.4161203935946!2d-123.01846222309891!3d49.30640276907365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548670f2acf0caf5%3A0xa180b9dfb101ef53!2sBUR-HAN%20Garden%20%26%20Lawn%20Care!5e0!3m2!1sen!2sca!4v1707501402244!5m2!1sen!2sca"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                  allowFullScreen
                ></iframe>{" "}
              </div>
              <div className="col-lg-6">
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  className="php-email-form"
                >
                  <div className="row">
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="firstName" className="visually-hidden">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        className="form-control"
                        id="firstName"
                        placeholder="First Name *"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="lastName" className="visually-hidden">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        className="form-control"
                        id="lastName"
                        placeholder="Last Name *"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="phone" className="visually-hidden">Phone Number</label>
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        id="phone"
                        placeholder="Phone Number *"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="email" className="visually-hidden">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Email *"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="address" className="visually-hidden">Address</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        id="address"
                        placeholder="Address *"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="postalcode" className="visually-hidden">Postal Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="postalcode"
                        id="postalcode"
                        placeholder="PostalCode *"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="select-city" className="visually-hidden">City</label>
                      <Select
                        id="select-city"
                        closeMenuOnSelect={true}
                        classNamePrefix="select-city"
                        className="select-city"
                        name="city"
                        placeholder="City *"
                        options={selectCity}
                        menuPortalTarget={document.body}
                        menuPosition={"fixed"}
                        styles={styles}
                        isSearchable={false}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                      <label htmlFor="services" className="visually-hidden">Services</label>
                      <Select
                        id="services"
                        isMulti
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        classNamePrefix="select"
                        className="select"
                        name="services"
                        placeholder="Services *"
                        options={servicesOption}
                        menuPortalTarget={document.body}
                        menuPosition={"fixed"}
                        styles={styles}
                        isSearchable={false}
                        required
                      />
                    </div>
                    <div className="col-md-12 form-group mb-3">
                      <label htmlFor="hearaboutus" className="visually-hidden">How did you hear about us</label>
                      <Select
                        id="hearaboutus"
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        classNamePrefix="select"
                        className="select"
                        name="hearaboutus"
                        placeholder="How did you hear about us? *"
                        options={hearaboutusOption}
                        menuPortalTarget={document.body}
                        menuPosition={"fixed"}
                        styles={styles}
                        isSearchable={false}
                        required
                      />
                    </div>
                  </div>
                  <label htmlFor="requiredservices" className="visually-hidden">Required Services</label>
                  <textarea
                    id="requiredservices"
                    name="requiredservices"
                    className="col-md-12 form-group mb-3 form-control"
                    placeholder="Required Services *"
                    rows="4"
                    required
                  />
                  <div className="text-center">
                    <button type="submit" name="submit">
                      Get A Quote
                    </button>
                  </div>
                </form>
                {/* Popup form message */}
                {showSuccessMessage && (
                  <div className="popup active">
                    <div className="popup-content">
                      <i
                        className="fa fa-check main-content__checkmark"
                        id="checkmark"
                      ></i>
                      <h2>Thank you for contacting us!</h2>
                      <h3>
                        We'll get back to you as soon as possible. <br />
                        Follow us on Social:
                      </h3>
                      <div className="social">
                        <a
                          href="https://www.facebook.com/bhgardenandlawncare"
                          className="social d-flex align-items-center"
                          aria-label="BUR-HAN Garden and Lawn Care on Facebook"
                        >
                          <i className="bi bi-facebook"></i>
                        </a>
                        <a
                          href="https://www.instagram.com/bhgardenandlawncare"
                          className="social d-flex align-items-center"
                          aria-label="BUR-HAN Garden and Lawn Care on Instagram"
                        >
                          <i className="bi bi-instagram"></i>
                        </a>
                        <a
                          href="https://www.youtube.com/user/readyforvideo"
                          className="social d-flex align-items-center"
                          aria-label="BUR-HAN Garden and Lawn Care on YouTube"
                        >
                          <i className="bi bi-youtube"></i>
                        </a>
                        <a
                          href="https://www.pinterest.ca/bhgardenandlawn"
                          className="social d-flex align-items-center"
                          aria-label="BUR-HAN Garden and Lawn Care on Pinterest"
                        >
                          <i className="bi bi-pinterest"></i>
                        </a>
                      </div>
                      <button onClick={handleReload}>
                        <span>Back to the Homepage </span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* -------------- END OF CONTACT -------------*/}
        </>
)}